<template>
  <v-container id="inspire">
    <div class="container-inner">
      <PageTitle title="Edit Item" />
      <div class="home-content">
        <v-form
          class="create-item--form"
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-row>
            <v-col sm="12" md="6" lg="6" cols="12">
              <div class="header-content">Info</div>
              <v-row>
                <v-col cols="12">
                  <span class="label-text">Item Name *</span>
                  <div class="input-mb input-box">
                    <v-text-field
                      dense
                      placeholder="Enter Item name"
                      v-model="itemToSubmit.name"
                      :rules="nameRules"
                      required
                      maxlength="128"
                      class="r-field item-name-field"
                      :append-outer-icon="
                        nameErrCnt == 0 ? '' : isValidatedName ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle'
                      "
                      @blur="isValidatedNameMethod"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span class="label-text">SKU</span>
                  <div class="input-mb input-box">
                    <v-text-field
                      dense
                      placeholder="Enter SKU"
                      v-model="itemToSubmit.sku"
                      :rules="skuRules"
                      maxlength="128"
                      @blur="isValidatedSKUMethod"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <span class="label-text">Quantity</span>
                  <div class="input-mb input-box">
                    <v-text-field
                      dense
                      type="number"
                      min="0"
                      step="1"
                      placeholder="0"
                      maxlength="8"
                      :rules="numberRules"
                      v-model="itemToSubmit.quantity"
                      @blur="isValidatedQuantifyMethod"
                    />
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="enable-alerts-switch d-flex justify-end">
                    <div class="enable-alerts-switch__label">
                      enable alert
                    </div>
                    <div>
                      <v-switch v-model="alertActive" inset color="rgb(121, 114, 191)"/>
                    </div>
                    <div>
                      <div style="margin-top: 2px" :class="{
                        'd-flex flex-column switch-alert justify-end cursor-pointer': alertStatus,
                        '': alertActive && !alertStatus
                      }"
                        @mouseover="bellHover"
                        :disabled="!alertActive">
                      <span class="off-alert-text">
                        {{ alertStatus ? 'Click to edit alert' : '' }}
                      </span>
                        <img v-if="alertActive"
                          src="@/assets/icons/svg/bell-white.svg"
                          style="padding: 6px; background-color: #7972bf; height: 28px; width: 28px; border-radius: 4px;"
                          @click="showAddAlertDialog"/>
                        <img
                          v-else
                          src="@/assets/icons/svg/bell-no-white.svg"
                          style="
                            padding: 6px;
                            background-color: #dbdbdb;
                            height: 28px;
                            width: 28px;
                            border-radius: 4px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <span class="label-text">Price, <span class="itemCurrency">{{ getActiveWarehouse.currency.code }}</span></span>
                  <div class="input-mb input-box" id="input-mb">
                    <v-text-field
                      dense
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Enter Price"
                      :rules="numberRules"
                      v-model="itemToSubmit.price"
                    />
                  </div>
                </v-col>
                <v-col cols="6">
                  <span class="label-text">Total value, <span class="itemCurrency">{{ getActiveWarehouse.currency.code }}</span></span>
                  <div class="input-mb input-box">
                    <v-text-field
                      readonly
                      dense
                      type="number"
                      min="0"
                      placeholder="0"
                      v-model="value"
                      :hide-details="true"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span class="label-text">Weight</span>
                  <v-row>
                    <v-col cols="9">
                      <div class="input-mb input-box d-flex flex-nowrap">
                        <v-text-field
                          dense
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="0"
                          :rules="numberRules"
                          v-model="itemToSubmit.weight"
                        />
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="input-mb input-box d-flex flex-nowrap">
                        <v-select
                          :items="getActiveWarehouse.weightUnits"
                          v-model="itemToSubmit.weightUnit"
                          placeholder="unit"
                          required
                          class="r-field general-settings-select"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-tooltip top transition="fade-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <span class="label-text" v-bind="attrs" v-on="on">
                          Dimensions&nbsp;<img src="@/assets/icons/svg/info.svg" style="height: 16px; width: 16px; top: 2px; position: relative" class="cursor-pointer" border="0" />
                        </span>
                    </template>
                    <span>Length x Width x Height</span>
                  </v-tooltip>
                  <v-row>
                    <v-col cols="9">
                      <div class="input-mb input-box d-flex flex-nowrap">
                        <v-text-field
                          dense
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="0"
                          :rules="numberRules"
                          v-model="itemToSubmit.length"
                        />
                        <span class="itemDimensions_space">x</span>
                        <v-text-field
                          dense
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="0"
                          :rules="numberRules"
                          v-model="itemToSubmit.width"
                        />
                        <span class="itemDimensions_space">x</span>
                        <v-text-field
                          dense
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="0"
                          :rules="numberRules"
                          v-model="itemToSubmit.height"
                        />
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="input-mb input-box d-flex flex-nowrap">
                        <v-select
                          :items="getActiveWarehouse.dimensionUnits"
                          v-model="itemToSubmit.dimensionUnit"
                          placeholder="unit"
                          required
                          class="r-field general-settings-select"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span class="label-text">Notes</span>
                  <div class="input-mb input-box">
                    <v-textarea
                      name="input-7-4"
                      label="Please share any additional information about your item"
                      hide-details="true"
                      single-line
                      dense
                      rows="5"
                      maxlength="255"
                      v-model="itemToSubmit.description"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="mr-3">
                <v-col sm="6">
                  <div class="itemSummary__item">
                    <span class="label-text">Created</span>
                    <span>{{ dateFormat(itemToSubmit.createdAt) }}</span>
                  </div>
                </v-col>
                <v-col sm="6">
                  <div class="itemSummary__item text-right">
                    <span class="label-text">Last Modified</span>
                    <span>{{ dateFormat(itemToSubmit.updatedAt) }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" />
            <v-col sm="12" md="5" lg="4" cols="12">
              <div class="header-content">Photos</div>
              <div class="upload_photo">
                <div id="my-strictly-unique-vue-upload-multiple-image">
                  <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove($event)"
                    @edit-image="editImage"
                    @data-change="dataChange"
                    @update-images="updateImagesArray"
                    :multiple-flag="true"
                    :data-images="itemToSubmit.images"
                    v-model="itemToSubmit.images"
                  />
                </div>
                <div class="note">
                  <div>
                    <img src="@/assets/icons/svg/info.svg" border="0" />
                  </div>
                  <div>
                    You can add up to 5 images<br>
                    Max Image Size up to 2Mb
                  </div>
                </div>
                <div class="errorMessage" v-if="uploadingFailed">
                  Error image uploading, try another image
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="pt-4">
            <v-col sm="12" md="6" lg="6" cols="12">
              <div class="header-content">Custom Fields</div>
              <component
                v-for="(customField, index) in itemToSubmit.customFields"
                :key="index"
                :is="customField.fieldType"
                :touch="'writingView'"
                :preloadedItem="customField"
                :letDelete="customField.applyTo !== 'ALL_ITEMS'"
                @newInput="(newVal) => { customField.value = newVal }"
                @delete="deleteCustomField(customField)"
              />
              <div class="flex flex-start align-center">
                <v-btn
                  color='transparent'
                  depressed
                  @click="showChooseCustomFieldPopup"
                  class='px-2'
                >
                  <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
                  <span class="text-subtitle-2 font-weight-bold">Add New Field</span>
                </v-btn>
                <v-divider vertical class="mx-2 my-1" />
                <v-btn
                  color='transparent'
                  depressed
                  @click="showCustomFieldsSection"
                  class='px-2'>
                  <span class="text-subtitle-2 font-weight-bold">Manage Custom Fields</span>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="1" />
            <v-col sm="12" md="5" lg="4" cols="12">
              <div class="header-content">QR / Barcode</div>
              <div v-if="!this.itemToSubmit.barcode">
                <div v-if="!showUploadBarcodeMessage" class="upload_photo upload_qrbarcodes">
                  <div id="qr-barcodes">
                    <vue-upload-multiple-image
                      idUpload="barcodeUpload"
                      idEdit="barcodeEdit"
                      @upload-success="uploadBarcodeSuccess"
                      @before-remove="beforeBarcodeRemove($event)"
                      @edit-image="editBarcode"
                      @data-change="changeBarcode"
                      @update-images="updateBarcode"
                      :data-images="barcodeImages"
                      :multiple-flag="false"
                      :browse-text="'Upload QR / Barcode'"
                      :upload-barcode="true"
                      v-model="barcodeImages"
                    />
                  </div>
                  <div class="note">
                    <div>
                      <img src="@/assets/icons/svg/info.svg" border="0" />
                    </div>
                    <div>
                      Accepted File Types: .jpg or .png<br>
                      Max Image Size up to 2Mb
                    </div>
                  </div>
                  <div v-if="uploadingFailed" class="errorMessage">
                    Error image uploading, try another image
                  </div>
                </div>
                <div v-else class="upload_wrapper">
                  <Loader />
                </div>
              </div>
              <div v-else class="upload_wrapper">
                <div class="delete_icon" title="Delete" @click="deleteBarcode">
                  <svg width="14" height="18" viewBox="0 0 14 18" fill="#73727E" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H1V16ZM3 6H11V16H3V6ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z"/>
                  </svg>
                </div>
                <VueBarcode
                  v-if="itemToSubmit.barcodeFormat !== 'QR_CODE'"
                  :value="itemToSubmit.barcode"
                  :format="barcodeFormat"
                  :ean128="isBarcodeEAN128" />
                <VueQRCodeComponent
                  v-if="itemToSubmit.barcodeFormat === 'QR_CODE'"
                  :text="itemToSubmit.barcode"
                  :size="128" />
              </div>
            </v-col>
          </v-row>
          <v-row class="pt-4">
            <v-col sm="10" md="7" lg="7" cols="12">
              <div class="header-content">Item's Locations</div>
              <WarehouseMapItemAssign
                :warehouseMap="getActiveWarehouse.map"
                :item="itemToSubmit"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-left pt-10">
                <v-btn  @click.stop="cancel" depressed class="cancel-btn">
                  Cancel
                </v-btn>
                <v-btn tabindex='1' @click="validate" depressed :disabled="!valid" class="save-item-btn save-btn">
                  Save
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
    <UnsavedChangesPopup />
    <AddEditAlertPopup
      :item="itemToSubmit"
      @saveAlert='saveAlert'
    />
    <DeleteAlertPopup :item="itemToSubmit" />
    <ChooseCustomFieldPopup
      v-if='letShowChooseCustomFieldPopup'
      @selected-fields="selectedFields"
      :haveItems="itemToSubmit.customFields.map(cf => cf.customFieldId)"
    />
    <LoaderPopup :loader="loader" />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import VueUploadMultipleImage from '@/components/upload-image/VueUploadMultipleImage'
import UnsavedChangesPopup from '@/components/popup/UnsavedChangesPopup'
import AddEditAlertPopup from '@/components/popup/AddEditAlertPopup'
import DeleteAlertPopup from '@/components/popup/DeleteAlertPopup'
import ChooseCustomFieldPopup from '@/components/popup/ChooseCustomField'
import PageTitle from '@/components/page/PageTitle'
import Loader from '@/views/Loader'
import {
  SET_ADD_EDIT_ALERT_POPUP_SHOW,
  MODULE_POPUP,
  SET_UNSAVED_CHANGES_POPUP_SHOW,
  MODULE_FORM,
  SET_FORM_DATA_ORIGIN,
  SET_FORM_DATA_NEW,
  SET_NEED_CHECK_FORM_OFF,
  SET_PENDING_ALERT_TO_SAVE,
  SET_CUSTOM_FIELD_POPUP_SHOW
} from '@/store/constant/mutation-types'
import smallTextBox from '@/components/customFields/smallTextBox'
import largeTextBox from '@/components/customFields/largeTextBox'
import roundNumber from '@/components/customFields/roundNumber'
import decimalNumber from '@/components/customFields/decimalNumber'
import phoneNumber from '@/components/customFields/phoneNumber'
import email from '@/components/customFields/email'
import webLink from '@/components/customFields/webLink'
import dateField from '@/components/customFields/dateField'
import checkBox from '@/components/customFields/checkBox'
import dropDown from '@/components/customFields/dropDown'
import { fieldsNamesFromBE } from '@/utils/customFields'
import serviceCustomField from '@/services/customField'
import alertsService from '@/services/alerts'
import VueBarcode from 'vue-barcode'
import VueQRCodeComponent from 'vue-qrcode-component'
import WarehouseMapItemAssign from '@/components/warehouses/warehouseMapItemAssign'
import { SETTINGS_PAGE_CUSTOM_FIELDS } from '@/constant'
import LoaderPopup from '@/components/popup/loaderPopup'

export default {
  name: 'Home',
  components: {
    Loader,
    LoaderPopup,
    VueUploadMultipleImage,
    UnsavedChangesPopup,
    AddEditAlertPopup,
    DeleteAlertPopup,
    ChooseCustomFieldPopup,
    PageTitle,
    smallTextBox,
    largeTextBox,
    roundNumber,
    decimalNumber,
    phoneNumber,
    email,
    webLink,
    dateField,
    checkBox,
    dropDown,
    VueBarcode,
    VueQRCodeComponent,
    WarehouseMapItemAssign
  },
  data() {
    return {
      barcodeMap: {
        QR_CODE: 'QR_CODE',
        CODE_128: 'CODE128',
        CODE_39: 'CODE39',
        EAN_13: 'EAN13',
        EAN_8: 'EAN8',
        UPC_A: 'UPC',
        UPC_B: 'UPC',
        ITF: 'ITF'
      },
      loader: false,
      alertStatus: false,
      notificationShowingTime: 5000,
      alertSelectedPeoples: '',
      alertType: '',
      alertQuantity: 100,
      searchUser: '',
      changedFlag: false,
      sendAlertToMembers: false,
      sendAlertToOwners: false,
      valid: true,
      nameErrCnt: 0,
      skuErrCnt: 0,
      quantifyErrCnt: 0,
      value: '',
      params: [
        {
          foo: 0,
          placeholder: '',
          type: 0
        },
        {
          foo: '',
          placeholder: 'Enter Min Level',
          type: 1
        }
      ],
      itemToSubmit: {},
      chips: [],
      select: ['add-tags-with', 'enter', 'tab', 'paste'],
      folders: [],
      confirmDialog: false,
      nameRules: [(value) => !!value || 'Please enter name'],
      skuRules: [],
      numberRules: [(value) => (!isNaN(+value) && value >= 0) || 'Invalid number format'],
      imageFormData: [],
      itemList: [],
      uploadingFailed: false,
      barcodeImages: [],
      barcodeFormData: [],
      showUploadBarcodeMessage: false,
      itemId: '',
      tmpAlertActive: false,
      bellStatus: false,
      addLocation: false
    }
  },
  computed: {
    ...mapGetters('user', ['invitedUsers']),
    ...mapGetters('inventory', ['categories']),
    ...mapGetters('popup', ['alertPendingToSave', 'showAddEditAlertPopup']),
    ...mapGetters('warehouses', ['getActiveWarehouse']),

    barcodeFormat() {
      return this.barcodeMap[this.itemToSubmit.barcodeFormat]
    },
    isBarcodeEAN128() {
      return String(this?.itemToSubmit?.barcodeFormat).indexOf('EAN_128') === 0
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    tinySmall() {
      return this.$vuetify.breakpoint.xsOnly
    },
    tinyMedium() {
      return this.$vuetify.breakpoint.smOnly
    },
    tinyDesktop() {
      return this.$vuetify.breakpoint.mdAndUp
    },
    alertActive: {
      get: function () {
        return this.alertPendingToSave ? !this.alertPendingToSave.archived : false
      },
      set: function (newVal) {
        this.alertStatus = newVal

        const time = setTimeout(() => {
          this.alertStatus = false
          clearTimeout(time)
        }, 5000)

        const payload = {
          itemId: this.itemToSubmit.id,
          type: this.itemToSubmit.alert.type,
          value: this.itemToSubmit.alert.value,
          users: this.itemToSubmit.alert.users,
          archived: !newVal
        }
        this.$store.commit(`${MODULE_POPUP}/${SET_PENDING_ALERT_TO_SAVE}`, payload)
      }
    },
    isValidatedName() {
      const validRegEx = /\S+/
      return (
        this.itemToSubmit.name !== null &&
        validRegEx.test(this.itemToSubmit.name)
      )
    },
    letShowChooseCustomFieldPopup() {
      return this.$store.getters['popup/showChooseCustomFieldPopup']
    },
    isValidatedQuantify() {
      const validRegEx = /\S+/
      return (
        this.itemToSubmit.quantity !== null &&
        validRegEx.test(this.itemToSubmit.quantity)
      )
    }
  },
  watch: {
    showAddEditAlertPopup(v) {
      if (!v) {
        const vmAlert = this.alertPendingToSave
        if (!(vmAlert.type && vmAlert.value && vmAlert.users)) {
          this.alertActive = false
        }
      }
    },
    async alertActive(v) {
      if (v && this.alertStatus) {
        this.$store.commit(`${MODULE_POPUP}/${SET_ADD_EDIT_ALERT_POPUP_SHOW}`, true)
      } else if (!v && this.itemToSubmit.alert.users.length) {
        const response = await alertsService.deleteAlert({ alertId: this.itemToSubmit.alert.id })
        if (response.data.error.type !== 200) {
          this.$store.dispatch('showSubmitFormErrorPopup', {
            title: 'Error to delete alert',
            message: response.data.error.message
          })
        }
      }
    },
    getActiveWarehouse() {
      this.$router.push({ name: 'Inventory' })
    },
    isValidatedName: {
      deep: true,
      handler: function (newVal) {
        this.nameErrCnt++
      }
    },
    isValidatedSKU: {
      deep: true,
      handler: function (newVal) {
        this.skuErrCnt++
      }
    },
    isValidatedQuantify: {
      deep: true,
      handler: function (newVal) {
        this.quantifyErrCnt++
      }
    },
    itemToSubmit: {
      deep: true,
      handler: function (val, newVal) {
        this.value = (this.itemToSubmit.quantity * this.itemToSubmit.price).toFixed(2)
        this.$store.commit(
          `${MODULE_FORM}/${SET_FORM_DATA_NEW}`,
          this.itemToSubmit
        )
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if ((+to.params.id).isNaN) {
      next(vm => {
        vm.$router.replace({ name: 'Inventory' })
      })
    } else {
      next()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      !(+from.params.id).isNaN &&
      this.$store.getters[`${MODULE_FORM}/isNeedCheckForm`] &&
      this.$store.getters[`${MODULE_FORM}/isFormDataChanged`]
    ) {
      this.$store.commit(
        `${MODULE_POPUP}/${SET_UNSAVED_CHANGES_POPUP_SHOW}`,
        true
      )
      next(false)
    } else {
      next()
    }
  },
  async created() {
    this.itemId = +this.$route.params.id
    if (!this.getActiveWarehouse || isNaN(this.itemId)) {
      this.$router.replace({ name: 'Inventory' })
    }

    this.itemToSubmit = await this.getItemById(this.itemId)
    if (typeof this.itemToSubmit !== 'object') {
      this.$router.replace({ name: 'Inventory' })
    }

    if (this.itemToSubmit.inventory?.currency) {
      this.currentCurrency = this.itemToSubmit.inventory.currency.code
    }

    this.itemToSubmit.customFields.forEach(cf => {
      cf.fieldType = fieldsNamesFromBE.get(cf.fieldType).name
      if (!Object.hasOwn(cf, 'value')) {
        cf.value = cf.defaultValue
      }

      if (cf.type.toUpperCase() === 'ARRAY' && cf.value !== null) {
        cf.value = isNaN(cf.value) ? null : parseInt(cf.value)
      }
    })

    const images = this.itemToSubmit.images.map(img => {
      return {
        path: img,
        highlight: 0
      }
    })
    if (images.length) {
      images[0].highlight = 1
    }
    this.itemToSubmit.images = images

    if (!this.itemToSubmit.alert) {
      this.itemToSubmit.alert = {}
    }

    this.$store.commit(`${MODULE_FORM}/${SET_FORM_DATA_ORIGIN}`, this.itemToSubmit)
  },
  methods: {
    ...mapActions('inventory', [
      'editItem',
      'getItemById',
      'uploadImages',
      'uploadBarcode'
    ]),
    ...mapActions('alerts', ['addAlert', 'updateAlert', 'updateNotification']),
    saveAlert(alert) {
      this.itemToSubmit.alert = alert
    },
    selectedFields(customFields) {
      const usedCustomFieldIds = this.itemToSubmit.customFields.map(cf => cf.customFieldId)
      customFields
        .filter(cf => usedCustomFieldIds.indexOf(cf.customFieldId) === -1)
        .forEach(cf => {
          this.itemToSubmit.customFields.push({
            id: this.itemToSubmit.id + '-' + cf.id,
            itemId: this.itemToSubmit.id,
            customFieldId: cf.id,
            fieldType: fieldsNamesFromBE.get(cf.fieldType).name,
            type: String(fieldsNamesFromBE.get(cf.fieldType).type).toUpperCase(),
            name: cf.name || '',
            placeholder: cf.placeholder || '',
            defaultValue: cf.defaultValue || '',
            value: cf.defaultValue || '',
            applyTo: cf.applyTo,
            customFieldArrayValues: cf.customFieldArrayValues
          })
        })
    },
    async deleteCustomField(customField) {
      await serviceCustomField.deleteCustomFieldFromItem({
        itemId: this.itemToSubmit.id,
        customFieldId: customField.customFieldId
      })

      const index = this.itemToSubmit.customFields.findIndex(cf => cf.customFieldId === customField.customFieldId)
      if (index !== -1) {
        this.itemToSubmit.customFields.splice(index, 1)
      }
    },
    bellHover() {
      this.bellStatus = !this.bellStatus
    },
    showChooseCustomFieldPopup() {
      this.$store.commit(`${MODULE_POPUP}/${SET_CUSTOM_FIELD_POPUP_SHOW}`, true)
    },
    showCustomFieldsSection() {
      this.$store.dispatch('setSettingsPageSection', SETTINGS_PAGE_CUSTOM_FIELDS)
      this.$router.push({ name: 'UserSettingsCustomField' })
    },
    showAddAlertDialog() {
      this.$store.commit(
        `${MODULE_POPUP}/${SET_ADD_EDIT_ALERT_POPUP_SHOW}`,
        true
      )
    },
    cancel() {
      this.$router.push('/inventory')
      this.$store.commit(`${MODULE_POPUP}/${SET_PENDING_ALERT_TO_SAVE}`, null)
    },
    uploadImageSuccess(formData, index, fileList) {
      this.uploadingFailed = false
      this.imageFormData.push(formData)
      this.changedFlag = true
    },
    updateImagesArray(formData, isCreatedImage, findingIndex) {
      if (isCreatedImage) {
        this.imageFormData[findingIndex] = formData
      } else {
        this.itemToSubmit.images.splice(findingIndex, 1)
        this.imageFormData.unshift(formData)
      }
      this.changedFlag = true
      this.uploadingFailed = false
    },

    beforeRemove(isCreatedImage, findingIndex) {
      if (isCreatedImage) {
        this.imageFormData.splice(findingIndex, 1)
      } else {
        this.itemToSubmit.images.splice(findingIndex, 1)
      }
      this.changedFlag = true
    },

    async uploadBarcodeSuccess(formData, index, fileList) {
      if (!formData) {
        return
      }

      this.showUploadBarcodeMessage = true
      const res = await this.uploadBarcode(formData)
      this.showUploadBarcodeMessage = false
      if (res.code && res.format) {
        this.itemToSubmit.barcode = res.code
        this.itemToSubmit.barcodeFormat = res.format
      }
    },

    beforeBarcodeRemove(isCreatedImage, findingIndex) {
      this.deleteBarcode()
    },

    deleteBarcode() {
      this.barcodeFormData = []
      this.barcodeimage = []
      this.itemToSubmit.barcode = ''
      this.itemToSubmit.barcodeFormat = ''
      this.changedFlag = true
    },

    editBarcode(formData, index, fileList) {
    },

    changeBarcode () {
    },

    updateBarcode() {
    },

    async validate() {
      if (!this.$refs.form.validate()) {
        this.nameErrCnt = 1
        this.skuErrCnt = 1
        this.quantifyErrCnt = 1
        return
      }

      if (this.imageFormData !== '') {
        this.uploadingFailed = false
        await this.uploadImages(this.imageFormData).then((res) => {
          if (res === 'Uploading failed') {
            this.uploadingFailed = true
            return
          }
          res.forEach((image) => {
            this.itemToSubmit.images.push(image)
          })
        })
        if (this.uploadingFailed) {
          return
        }
      }

      if (this.itemToSubmit.images) {
        const onlyUrlImagesArray = []
        this.itemToSubmit.images.forEach((item) => {
          onlyUrlImagesArray.push(item.path || item)
        })
        this.itemToSubmit.images = onlyUrlImagesArray
      }

      if (Array.isArray(this.itemToSubmit.customFields)) {
        this.itemToSubmit.customFields.forEach(cf => {
          cf.value = String(cf.value)
        })
      }

      const payload = {
        id: this.itemToSubmit.id,
        inventoryId: this.itemToSubmit.inventoryId,
        categoryId: this.itemToSubmit.categoryId,
        name: this.itemToSubmit.name,
        sku: this.itemToSubmit.sku,
        barcode: this.itemToSubmit.barcode,
        barcodeFormat: this.itemToSubmit.barcodeFormat,
        images: this.itemToSubmit.images ? this.itemToSubmit.images : '',
        description: this.itemToSubmit.description,
        quantity: parseInt(this.itemToSubmit.quantity),
        price: parseFloat(this.itemToSubmit.price),
        customFields: this.itemToSubmit.customFields,
        length: this.itemToSubmit.length,
        width: this.itemToSubmit.width,
        height: this.itemToSubmit.height,
        dimensionUnit: this.itemToSubmit.dimensionUnit,
        weight: this.itemToSubmit.weight,
        weightUnit: this.itemToSubmit.weightUnit,
        warehouseLocations: this.itemToSubmit.warehouseLocations
      }

      this.$store.commit(`${MODULE_FORM}/${SET_NEED_CHECK_FORM_OFF}`)
      this.loader = true
      await this.editItem(payload)
      this.loader = false
    },
    editImage(formData, index, fileList) {
    },
    dataChange(data) {
    },
    setQuantity(event) {
      this.itemToSubmit.quantity = event
    },
    isValidatedNameMethod() {
      const validRegEx = /\S+/
      if (
        this.itemToSubmit.name === '' &&
        !validRegEx.test(this.itemToSubmit.name)
      ) {
        this.nameErrCnt = 1
      }
    },
    isValidatedSKUMethod() {
      const validRegEx = /\S+/
      if (
        this.itemToSubmit.sku === '' &&
        !validRegEx.test(this.itemToSubmit.sku)
      ) {
        this.skuErrCnt = 1
      }
    },
    isValidatedQuantifyMethod() {
      const validRegEx = /\S+/
      if (
        this.itemToSubmit.quantity === '' &&
        !validRegEx.test(this.itemToSubmit.quantity)
      ) {
        this.quantifyErrCnt = 1
      }
    },
    dateFormat(date) {
      return moment.utc(date).local().format('MM/DD/YYYY hh:mma')
    }
  }
}
</script>

<style lang="scss">
#inspire {
  ::v-deep .v-messages__message {
    color: #ff5252;
    font-size: 13px;
    text-align: left;
    line-height: 1.3;
    padding: 3px 0;
  }

  .v-text-field--outlined {
    border-color: rgba(192, 0, 250, 0.986);
  }

  .v-messages,
  .v-text-field__details {
    min-height: 0 !important;
  }

  .v-text-field__details {
    padding: 0 4px !important;
  }

  .v-input--selection-controls {
    margin-top: 0 !important;
    margin-right: 0 !important;
  }

  .create-item--form {
    max-width: 1400px;
    padding-bottom: 60px;

    .input-row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      > div {
        width: 100%;
      }

      .v-text-field {
        margin: 0;
        padding: 0;
      }

      .v-text-field__details,
      .v-messages {
        min-height: 0;
      }
    }
  }
}
</style>

<style scoped lang="scss">
::v-deep .v-textarea {
  textarea {
    overflow: hidden !important;
  }

  .v-label {
    padding: 8px 18px;
    line-height: 30px;
    height: auto;
  }
}

::v-deep .container {
  width: 100%;
  padding: 0 !important;
  margin-right: auto;
}

.switch-alert {
  position: relative;
  left: -10px;
  top: -25px;
  height: 53px;
  width: 53px;
  .off-alert-text {
    display: none;
  }
  .off-alert-text {
    display: block;
    background-color: #383838;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    position: relative;
    left: 0;
    width: 143px;
    top: 64px;
    &:after {
      content: '';
      position: relative;
      top: -121%;
      left: -70%;
      width: 0;
      height: 0;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      border-bottom: solid 10px #383838;
      border-top: solid 10px transparent;
    }
  }
}

.set-alert {
  position: relative;
  left: -10px;
  top: -25px;
  height: 53px;
  width: 53px;
  .off-alert-text {
    display: none;
  }
  &:hover {
    .off-alert-text {
      display: block;
      background-color: #383838;
      color: white;
      padding: 2px 8px;
      border-radius: 4px;
      position: relative;
      left: 0;
      width: 143px;
      top: 64px;
      &:after {
        content: '';
        position: relative;
        top: -121%;
        left: -70%;
        width: 0;
        height: 0;
        border-left: solid 10px transparent;
        border-right: solid 10px transparent;
        border-bottom: solid 10px #383838;
        border-top: solid 10px transparent;
      }
    }
  }
  .off-alert-text {
    background-color: #383838;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    position: relative;
    left: 0;
    width: 65px;
    top: -7px;
    &:after {
      content: '';
      position: relative;
      top: 130%;
      left: -70%;
      width: 0;
      height: 0;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      border-top: solid 10px #383838;
    }
  }
}

.itemSummary {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;

  .itemSummary__item {
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    > span {
      white-space: nowrap;
      margin-right: 10px;
      &.label-text {
        text-transform: capitalize !important;
        letter-spacing: 1px !important;
      }
    }
  }
}

.itemDimensions_space {
  position: relative;
  padding-top: 15px;
  left: -10px;
  color: #9fa1af;
}
</style>
